/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AnalysisWriteForbiddenErrorCode = (typeof AnalysisWriteForbiddenErrorCode)[keyof typeof AnalysisWriteForbiddenErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisWriteForbiddenErrorCode = {
  analysis_read_only_access: "analysis_read_only_access",
  analysis_not_editable: "analysis_not_editable",
} as const;
